import React, { useMemo, useCallback } from 'react';
import classnames from 'classnames';
import connect from 'Shared/connect';
import { getCartLineItemsForVariants } from '../../../Cart/reducer';
import { selectVariant } from 'Shared/Product/action-creators';
import * as styles from './base.scss';
const ProductVariantSelector = ({ variants, isWeightProduct, preferedVariant, cartLineItems, selectedVariant, selectVariant, disabled, className, useNewDesign, hideUnitLabels, showAllVariants, showOnlySelectedVariant }) => {
    const selectableVariants = useMemo(() => {
        if (showOnlySelectedVariant) {
            return [selectedVariant];
        }
        if (showAllVariants) {
            return variants;
        }
        if (preferedVariant && cartLineItems.length > 1) {
            return [preferedVariant];
        }
        if (isWeightProduct) {
            return variants.filter(v => v.unitShortName === selectedVariant.unitShortName);
        }
        return variants;
    }, [preferedVariant, selectedVariant, cartLineItems, isWeightProduct, variants]);
    const setSelectedVariant = useCallback((newUnitShortName) => {
        const variant = variants.find(v => v.unitShortName === newUnitShortName);
        return selectVariant(variant.code, variants);
    }, [variants, selectedVariant]);
    return (React.createElement(React.Fragment, null, selectableVariants.map((selectableVariant, index) => (React.createElement("div", { "data-opti-id": "component-unit-selector-radio-button", key: index, onClick: () => setSelectedVariant(selectableVariant.unitShortName), className: classnames(styles.placeholderText, {
            [styles.selected]: selectedVariant.unitShortName === selectableVariant.unitShortName,
            [className]: selectedVariant.unitShortName === selectableVariant.unitShortName,
            [styles.disabled]: disabled,
            [styles['description--title']]: useNewDesign
        }) }, !!!hideUnitLabels && selectableVariant.unitShortName)))));
};
export default connect((state, { variants }) => ({
    cartLineItems: getCartLineItemsForVariants(state, variants),
}), (dispatch, { variants }) => ({
    selectVariant: (code) => dispatch(selectVariant(code, variants)),
}))(ProductVariantSelector);
